import React, { useState, useContext, useMemo, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import GetAppIcon from '@mui/icons-material/GetApp';

import UserService from "services/UserService";
import axios from "axios";
import { getGEBScripts } from "services/ConfigServices";
import { scriptText } from "variables/MBM/geb";
import { typeData } from "variables/MBM/lists/schedule";
import moment from "moment";
import CustomSelect from "components/Input/CustomSelect.js";
import { downloadCSV } from "utilities/exporttabletocsv";
import Button from "components/CustomButtons/Button.js";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
// import AddSchedule from "./AddSchedule";
import { NotificationManager } from "react-notifications";
import AddScript from "./AddScript";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: -8px;
`;


export default function useScriptsTable(currentWorkspace) {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const workspace_admin = permis.includes("mbm_workspaces_admin");
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [totalRows, setTotalRows] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const url = getGEBScripts(currentWorkspace?.id);
  const [results, setResults] = useState({ meters: [] });
  const [loading, setLoading] = useState(false);
  const [selectedScripts, setSelectedScripts] = useState([]);

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  useEffect(() => {
    if (currentWorkspace && currentWorkspace.id) {
      //setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          url,
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      fetchData();
    }
  }, [refresh]);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px", marginRight: "10px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );

  const filteredItems = _.get(results, `scripts`, []).filter(
    (item) =>
      (item.parameters?.name && item.parameters?.name.toLowerCase().includes(filterText.toLowerCase())) ||
      (item.parameters?.description && item.parameters?.description.toLowerCase().includes(filterText.toLowerCase()))
  )
    ;

  const setNotification = (status, text) => {
    if (status === 'success') {
      NotificationManager.success(text);
    }
    else {
      NotificationManager.error(text);
    }
  };

  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);
    let exportarray = selectedScripts.map((item) => {
      let scripttoexport = {};
      scripttoexport[scriptText.id] = item.id;
      scripttoexport[scriptText.name] = item.parameters?.name;
      scripttoexport[scriptText.description] = item.parameters?.description;
      scripttoexport[scriptText.destination] = item.destination;
      scripttoexport[scriptText.triggers] = item.triggers;
      scripttoexport[scriptText.scriptpython] = item.scriptpython;
      return scripttoexport;
    });

    return (
      <>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {workspace_admin && (
          <>
            <UploadButton type="button" onClick={handleClear}>
              <AddScript
                refetch={refreshTable}
                onClick={handleClear}
                setLoading={setLoading}
                setNotification={setNotification}
                wpgroup={currentWorkspace?.idgroup}
                workspaceid={currentWorkspace?.id}
              />
            </UploadButton>
          </>
        )}
        <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedScripts || selectedScripts.length < 1} />
        </UploadButton>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedScripts, results]);

  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedScripts,
    setLoading,
  };
}
